import React from "react";

import { Knob } from "components/shared/ReactRotaryKnob";
import { Avatar, Box, Typography } from "@material-ui/core";
import { Grid, Slider } from "@mui/material";
import UpDownButton from "components/shared/UpDownButton";

import marbelHallIR from "assets/effects/Marbel.mp4";
import smokingRoomIR from "assets/effects/Smoke.mp4";
import pannerKnob from "assets/knobSkins/phase2panner";
import filterKnob from "assets/knobSkins/phase2filter";

import muteButtonOff from "assets/phase2/3_off.png";
import muteButtonOn from "assets/phase2/3_on.png";
import soloButtonOff from "assets/phase2/4_off.png";
import soloButtonOn from "assets/phase2/4_on.png";
import filterResetBtn from "assets/phase2/14.png";
import sliderBaseBackground from "assets/phase2/5.png";
import sliderSlide from "assets/phase2/6.png";

const styles = {
  layerContainer: {
    left: "4%",
    height: "95%",
    width: "100%",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    // backgroundImage: `url(${layerBack})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    // marginTop:"-8%"
  },
  toggleButton: {
    position: "relative",
    top: "10%",
    left: "20%",
    width: "60%",
    height: "60%",
  },
  toggleButtonHorizontal: {
    position: "relative",
    top: "10%",
    left: "20%",
    width: "50%",
    height: "50%",
    // transform:"rotate(90deg)",
  },
  toggleButtonImage: {
    width: "100%",
    height: "100%",
    display: "inline-block",
  },
  layerNameTYpography: {
    position: "relative",
    // top: "5.5vw",
    // left: "-1vw",
    fontSize: "5px",
    left: "1%",
    top: "1%",
    textAlign: "center",
  },
  knobGrid: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
  },
  muteControlButton: {
    top: "15%",
    left: "10%",
    height: "80%",
    position: "relative",
  },
  panner: {
    width: "100%",
    height: "21.43%",
    // backgroundColor: "cyan",
  },
  muteBox: {
    width: "100%",
    height: "14.28%",
    // paddingLeft:"10%",
    // backgroundColor: "limegreen",
  },
  slider: {
    width: "100%",
    height: "64.29%",
    justifyContent: "center",
    // backgroundColor: "lightsalmon",
  },
  sliderBase: {
    width: "85%",
    backgroundImage: `url(${sliderBaseBackground})`,
    // backgroundSize: "cover",
    // backgroundRepeat: "no-repeat",
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingBottom: "8%",
    paddingTop: "5%",
  },
  sliderSlide: {
    width: "60%",
    left: "10%",
    position: "relative",
    backgroundImage: `url(${sliderSlide})`,
    // backgroundSize: "cover",
    // backgroundRepeat: "no-repeat",
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  },
  fullContainer: {
    height: "100%",
    width: "100%",
  },
  filterResetBtn: {
    width: "90%",
    height: "80%",
    position: "relative",
    left: "5%",
    backgroundImage: `url(${filterResetBtn})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  },
};

class UniversalControler extends React.Component {
  // static AudioContext = window.AudioContext || window.webkitAudioContext;

  timestamps = [
    0, 18, 34, 50, 66, 82, 98, 114, 130, 146, 162, 178, 210, 242, 258, 290, 306,
    322, 338, 354, 370, 402, 434, 466, 474, 490, 498, 514, 530, 546, 562, 578,
    594, 610,
  ];

  constructor(props) {
    super(props);
    this.state = {
      volume: props.initialVolume,
      panning: props.initialPanning,
      muted: props.initialMuted,
      solo: props.initialSolo,
      eq1Connected: false,
      eq2Connected: false,
      reverb1Connected: false,
      reverb2Connected: false,
      reverb1Value: 0,
      reverb2Value: 0,
      eqFilter1Value: 0,
      eqFilter2Value: 0,
      // audioElement: null,
      selectedState: props.selected,
    };
    this.announcCurrenttime = props.announcCurrenttime;
    this.audioContext = props.audioContextInstance;
    console.log(this.audioContext)
    this.biquadFilter1 = this.audioContext.createBiquadFilter();
    this.biquadFilter2 = this.audioContext.createBiquadFilter();

    this.biquadFilter3 = this.audioContext.createBiquadFilter();
    this.biquadFilter4 = this.audioContext.createBiquadFilter();

    this.eq1GainNode = this.audioContext.createGain();
    this.eq2GainNode = this.audioContext.createGain();

    this.reverb1ConvFilter = this.audioContext.createConvolver();
    this.reverb2ConvFilter = this.audioContext.createConvolver();
    this.reverb1LowpassFilter = this.audioContext.createBiquadFilter();
    this.reverb1HighpassFilter = this.audioContext.createBiquadFilter();
    this.reverb2LowpassFilter = this.audioContext.createBiquadFilter();
    this.reverb2HighpassFilter = this.audioContext.createBiquadFilter();
    this.reverb1DryGainNode = this.audioContext.createGain();
    this.reverb1WetGainNode = this.audioContext.createGain();
    this.reverb2DryGainNode = this.audioContext.createGain();
    this.reverb2WetGainNode = this.audioContext.createGain();

    this.masterGain = this.audioContext.createGain();

    this.pannerNodeInstance = this.audioContext.createStereoPanner();

    this.biquadFilter1.type = "lowpass";
    this.biquadFilter1.frequency.value = 3475;
    this.biquadFilter1.Q.value = 0.698;

    this.biquadFilter2.type = "highpass";
    this.biquadFilter2.frequency.value = 500;
    this.biquadFilter2.Q.value = 0.668;

    this.biquadFilter3.type = "lowpass";
    this.biquadFilter3.frequency.value = 991;
    this.biquadFilter3.Q.value = 1;

    this.biquadFilter4.type = "highshelf";
    this.biquadFilter4.frequency.value = 465;
    this.biquadFilter4.gain.value = 10;
    this.biquadFilter4.Q.value = 8.775;

    this.reverb1LowpassFilter.type = "lowpass";
    this.reverb1LowpassFilter.frequency.value = 13000;
    this.reverb1LowpassFilter.Q.value = 1;

    this.reverb1HighpassFilter.type = "highpass";
    this.reverb1HighpassFilter.frequency.value = 300;
    this.reverb1HighpassFilter.Q.value = 1;

    this.reverb2LowpassFilter.type = "lowpass";
    this.reverb2LowpassFilter.frequency.value = 13000;
    this.reverb2LowpassFilter.Q.value = 1;

    this.reverb2HighpassFilter.type = "highpass";
    this.reverb2HighpassFilter.frequency.value = 300;
    this.reverb2HighpassFilter.Q.value = 1;

    fetch(marbelHallIR).then((res) => {
      res.arrayBuffer().then((arrayBuffer) => {
        this.audioContext
          .decodeAudioData(arrayBuffer)
          .then(
            (decodedBuffer) => (this.reverb1ConvFilter.buffer = decodedBuffer)
          );
      });
    });

    fetch(smokingRoomIR).then((res) => {
      res.arrayBuffer().then((arrayBuffer) => {
        this.audioContext
          .decodeAudioData(arrayBuffer)
          .then(
            (decodedBuffer) => (this.reverb2ConvFilter.buffer = decodedBuffer)
          );
      });
    });
  }

  eq1Connect() {
    console.log(this.props.name, "eq1Connect")
    this.audioTrack.connect(this.biquadFilter1);
    this.biquadFilter1.connect(this.biquadFilter2);
    this.biquadFilter2.connect(this.eq1GainNode);
    this.eq1GainNode.connect(this.masterGain);
    this.setState({ eq1Connected: true });
  }
  eq1Disconnect() {
    console.log(this.props.name, "eq1Disconnect")
    this.audioTrack.disconnect(this.biquadFilter1);
    this.biquadFilter1.disconnect(this.biquadFilter2);
    this.biquadFilter2.disconnect(this.eq1GainNode);
    this.eq1GainNode.disconnect(this.masterGain);
    this.setState({ eq1Connected: false });
  }

  eq2Connect() {
    console.log(this.props.name, "eq2Connect")
    this.audioTrack.connect(this.biquadFilter3);
    this.biquadFilter3.connect(this.biquadFilter4);
    this.biquadFilter4.connect(this.eq2GainNode);
    this.eq2GainNode.connect(this.masterGain);
    this.setState({ eq2Connected: true });
  }
  eq2Disconnect() {
    console.log(this.props.name, "eq2Disconnect")
    this.audioTrack.disconnect(this.biquadFilter3);
    this.biquadFilter3.disconnect(this.biquadFilter4);
    this.biquadFilter4.disconnect(this.eq2GainNode);
    this.eq2GainNode.disconnect(this.masterGain);
    this.setState({ eq2Connected: false });
  }

  reverb1Connect() {
    console.log(this.props.name, "reverb1Connect")
    this.audioTrack.connect(this.reverb1DryGainNode);
    this.reverb1DryGainNode.connect(this.masterGain);
    this.audioTrack.connect(this.reverb1ConvFilter);
    this.reverb1ConvFilter.connect(this.reverb1LowpassFilter);
    this.reverb1LowpassFilter.connect(this.reverb1HighpassFilter);
    this.reverb1HighpassFilter.connect(this.reverb1WetGainNode);
    this.reverb1WetGainNode.connect(this.masterGain);
    this.setState({ reverb1Connected: true });
  }
  reverb1Disconnect() {
    console.log(this.props.name, "reverb1Disconnect")
    this.audioTrack.disconnect(this.reverb1DryGainNode);
    this.reverb1DryGainNode.disconnect(this.masterGain);
    this.audioTrack.disconnect(this.reverb1ConvFilter);
    this.reverb1ConvFilter.disconnect(this.reverb1LowpassFilter);
    this.reverb1LowpassFilter.disconnect(this.reverb1HighpassFilter);
    this.reverb1HighpassFilter.disconnect(this.reverb1WetGainNode);
    this.reverb1WetGainNode.disconnect(this.masterGain);
    this.setState({ reverb1Connected: false });
  }

  reverb2Connect() {
    console.log(this.props.name, "reverb2Connect")
    this.audioTrack.connect(this.reverb2DryGainNode);
    this.reverb2DryGainNode.connect(this.masterGain);
    this.audioTrack.connect(this.reverb2ConvFilter);
    this.reverb2ConvFilter.connect(this.reverb2LowpassFilter);
    this.reverb2LowpassFilter.connect(this.reverb2HighpassFilter);
    this.reverb2HighpassFilter.connect(this.reverb2WetGainNode);
    this.reverb2WetGainNode.connect(this.masterGain);
    this.setState({ reverb2Connected: true });
  }

  reverb2Disconnect() {
    console.log(this.props.name, "reverb2Disconnect")
    this.audioTrack.disconnect(this.reverb2DryGainNode);
    this.reverb2DryGainNode.disconnect(this.masterGain);
    this.audioTrack.disconnect(this.reverb2ConvFilter);
    this.reverb2ConvFilter.disconnect(this.reverb2LowpassFilter);
    this.reverb2LowpassFilter.disconnect(this.reverb2HighpassFilter);
    this.reverb2HighpassFilter.disconnect(this.reverb2WetGainNode);
    this.reverb2WetGainNode.disconnect(this.masterGain);
    this.setState({ reverb2Connected: false });
  }

  handelMute() {
    if(this.state.solo) this.handelSolo()
    this.audioElement.volume = this.state.muted ? this.state.volume : 0;
    this.setState((prevState) => ({ muted: !prevState.muted }));
    // this.props.muteSideEffectFunction(this.props.layerId);
  }

  handelSolo() {
    if (this.state.solo){
      return this.setState((prevState) => ({ solo: !prevState.solo }));
    }
    if (this.state.muted) this.handelMute();
    
    this.setState((prevState) => ({ solo: !prevState.solo }));
    this.props.soloSideEffectFunction(this.props.layerId);
  }

  handelReverb1(newValue) {
    if (newValue === 0 && this.state.reverb1Connected) {
      this.reverb1Disconnect();
    }
    if (newValue > 0 && !this.state.reverb1Connected) {
      this.reverb1Connect();
    }
    this.reverb1WetGainNode.gain.setValueAtTime(
      newValue / 100,
      this.audioContext.currentTime
    );
    this.reverb1DryGainNode.gain.setValueAtTime(
      1 - newValue / 100,
      this.audioContext.currentTime
    );
    this.setState({ reverb1Value: newValue / 100 });
  }
  handelReverb2(newValue) {
    if (newValue === 0 && this.state.reverb2Connected) {
      this.reverb2Disconnect();
    }
    if (newValue > 0 && !this.state.reverb2Connected) {
      this.reverb2Connect();
    }
    this.reverb2WetGainNode.gain.setValueAtTime(
      newValue / 100,
      this.audioContext.currentTime
    );
    this.reverb2DryGainNode.gain.setValueAtTime(
      1 - newValue / 100,
      this.audioContext.currentTime
    );
    this.setState({ reverb2Value: newValue / 100 });
  }

  handelEQ1ValueChange(value) {
    if (value <= 0 && this.state.eq1Connected) {
      this.eq1Disconnect();
    }
    if (value > 0 && !this.state.eq1Connected) {
      this.eq1Connect();
    }

    if (value > 4 || value < 0) return;
    console.log(
      "eq1 value change called by ",
      this.props.name,
      " and the value is ",
      value * 0.25
    );
    this.eq1GainNode.gain.setValueAtTime(
      value * 0.25,
      this.audioContext.currentTime
    );
  }

  handelEQ2ValueChange(value) {
    if (value > 4 || value < -4) return;
    value = Math.abs(value);
    if (value === 0 && this.state.eq2Connected) {
      this.eq2Disconnect();
    }
    if (value != 0 && !this.state.eq2Connected) {
      this.eq2Connect();
    }
    this.eq2GainNode.gain.setValueAtTime(
      value * 0.25,
      this.audioContext.currentTime
    );
  }

  handelVolumeChange(newVolume) {
    this.audioElement.volume = this.state.muted ? 0 : newVolume;
    this.setState({ volume: newVolume });
  }
  handelPanningChange(newPan) {
    this.pannerNodeInstance.pan.value = newPan;
    this.setState({ panning: newPan });
  }

  play() {
    this.audioContext.resume();
    this.audioElement.play();
  }
  pause() {
    this.audioElement.pause();
  }
  stop() {
    // audioElement.pause();
    // audioElement.currentTime = trackEndTime;
    this.props.stateChanger(this.props.name, "readyToPlay");

    // setCurrentTrack((currentTrack) => currentTrack + 1);
  }
  toggleMute() {
    this.handelMute();
  }
  setMute(muteState) {
    if (muteState !== this.state.muted) this.handelMute();
  }
  changePlaybackSpeed(newSpeed) {
    if (!this.audioElement) return;
    this.audioElement.playbackRate = newSpeed;
  }
  changeCurrentTime(newPortion) {
    this.audioElement.currentTime = newPortion * this.audioElement.duration;
  }
  deselect() {
    this.setState({ selectedState: false });
  }

  componentDidMount() {
    if (this.props.isDecorative) return;

    this.audioElement = document.querySelector(`#${this.props.name}`);

    this.audioTrack = this.audioContext.createMediaElementSource(
      this.audioElement
    );

    this.audioElement.addEventListener("timeupdate", () => {
      if (
        isNaN(this.audioElement.duration) ||
        isNaN(this.audioElement.currentTime)
      )
        return 0;
        if(this.props.announcCurrenttime){
          this.props.announcCurrenttime(this.audioElement.currentTime);
        }
      let index = this.timestamps.filter(
        (element) => element < this.audioElement.currentTime
      ).length;
      let trackStartTime = this.timestamps[index - 1];
      let trackEndTime = this.timestamps[index];

      this.props.announceCurrentPortion(
        (this.audioElement.currentTime - trackStartTime) /
          (trackEndTime - trackStartTime)
      );
      if (this.audioElement.currentTime >= trackEndTime) {
        this.audioElement.pause();
        this.props.stateChanger(this.props.name, "ended");
      }
    });

    this.audioElement.addEventListener("waiting", () => {
      // console.log(name, "starts to wait", audioElementInstace.currentTime);
      this.props.stateChanger(this.props.name, "waiting");
    });
    this.audioElement.addEventListener("canplaythrough", () => {
      // console.log(
      //   name,
      //   "starts to play again",
      //   audioElementInstace.currentTime
      // );
      this.props.stateChanger(this.props.name, "readyToPlay");
    });
    // audioElementInstace.addEventListener("load",()=>{
    //   console.log(name,"loads for the first time", audioElementInstace.currentTime)
    //   stateChanger(name,"readyToPlay")
    // })
    this.audioElement.addEventListener("ended", () => {
      this.props.stateChanger(this.props.name, "ended");
    });

    this.audioTrack.connect(
      this.props.mergerNodeReference,
      0,
      this.props.layerNumber
    );

    this.audioTrack.connect(this.masterGain);
    this.masterGain.connect(this.pannerNodeInstance);
    this.pannerNodeInstance.connect(this.props.audioDestination);
  }

  render() {
    return (
      <Grid
        container
        direction="column"
        style={{
          height: "100%",
          gridColumnStart: "1",
          gridRowStart: "1",
          minWidth: 0,
          minHeight: 0,
        }}
      >
        <Grid item direction="row" style={{ height: "74%", width: "100%" }}>
          <div
            onClick={(e) => {
              this.setState({ selectedState: true });
              this.props.handelSelectionFunction(this.props.name);
              console.log(this.props.name, " Selected");
            }}
            style={{
              width: "16.5%",
              height: "100%",
              backgroundColor: this.state.selectedState ? "#ffff0022" : "",
              position: "relative",
              left: this.props.layerPosition * 16.5 + 1 + "%",
            }}
          >
            {this.props.isDecorative && (
              <div
                onClick={(e) => {
                  e.stopPropagation();
                }}
                style={{
                  width: "100%",
                  height: "100%",
                  backgroundColor: "#00000066",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  zIndex: 12,
                }}
              ></div>
            )}
            <Grid
              item
              container
              direction="column"
              style={{
                left: "4%",
                height: "95%",
                width: "100%",
                position: "relative",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                // backgroundImage: `url(${layerBack})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                // marginTop:"-8%"
              }}
              // className={classes.layerContainer}
            >
              <audio
                crossOrigin="anonymous"
                id={this.props.name}
                src={this.props.src}
              ></audio>
              <Grid item style={{ width: "100%", height: "21.43%" }}>
                <Knob
                  style={{
                    display: "inline-block",
                    width: "85%",
                    height: "73%",
                    left: "5%",
                    top: "10%",
                    // transform: "translate(-14.5%, -128%)",
                    // margin: "10px",
                    position: "relative",
                  }}
                  skin={pannerKnob}
                  min={-100}
                  max={100}
                  value={this.state.panning * 100}
                  unlockDistance={50}
                  clampMin={0}
                  clampMax={310}
                  rotateDegrees={-155}
                  onChange={(value) => {
                    const maxDistance = 50;
                    let distance = Math.abs(value - this.state.panning * 100);
                    if (distance > maxDistance) {
                      return;
                    } else {
                      this.handelPanningChange(value / 100.0);
                    }
                  }}
                />
                {/* <Typography className={classes.layerNameTYpography}>
              {name}
            </Typography> */}
              </Grid>

              <Grid container item style={{ width: "100%", height: "14.28%" }}>
                <Grid item xs={1} />
                <Grid
                  item
                  xs={5}
                  // className={classes.knobGrid}
                  style={styles.knobGrid}
                  onClick={() => this.handelMute(this.props.name)}
                >
                  <img
                    src={this.state.muted ? muteButtonOn : muteButtonOff}
                    style={styles.muteControlButton}
                    // className={classes.muteControlButton}
                  />
                </Grid>

                <Grid
                  item
                  xs={5}
                  // className={classes.knobGrid}
                  style={styles.knobGrid}
                  onClick={() => this.handelSolo(this.props.name)}
                >
                  <img
                    src={this.state.solo ? soloButtonOn : soloButtonOff}
                    // className={classes.muteControlButton}
                    style={styles.muteControlButton}
                  />
                </Grid>
                <Grid item xs={1} />
              </Grid>

              <Grid container item style={styles.slider}>
                <div style={styles.sliderBase}>
                  <Slider
                    sx={{
                      padding:`0 36%`,
                      '& input[type="range"]': {
                        WebkitAppearance: "slider-vertical",
                      },
                      "& .MuiSlider-track": {
                        backgroundColor: "#00ff00cc",
                      },
                      "& .MuiSlider-thumb": {
                        backgroundImage: `url(${sliderSlide})`,
                        backgroundSize: "100% auto",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        backgroundColor: "#00000000",
                        stroke: 0,
                        boxShadow: "none",
                        width: "60%",
                        left: "50.5%",
                        borderRadius: 0,
                        "::before": {
                          boxShadow: "none",
                        },
                      },
                    }}
                    orientation="vertical"
                    min={0}
                    max={100}
                    aria-label="Temperature"
                    valueLabelDisplay="auto"
                    value={this.state.volume * 100}
                    onChange={(e) => {
                      this.handelVolumeChange(e.target.value / 100);
                    }}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>

        <Grid
          item
          container
          direction="row"
          columns={80}
          display={this.state.selectedState ? "display" : "none"}
          style={{
            height: "26%",
            width: "97%",
            left: "1.5%",
            position: "relative",
          }}
        >
          <Grid item xs={13}>
            <div style={styles.filterResetBtn}></div>
          </Grid>
          <Grid item xs={23}>
            <Grid container style={styles.fullContainer}>
              <Grid item xs={6}>
                <Knob
                  style={{
                    display: "inline-block",
                    width: "70%",
                    height: "73%",
                    left: "15%",
                    top: "3%",
                    // transform: "translate(-14.5%, -128%)",
                    // margin: "10px",
                    position: "relative",
                  }}
                  skin={filterKnob}
                  min={0}
                  max={100}
                  value={this.state.reverb2Value * 100}
                  unlockDistance={50}
                  clampMin={0}
                  clampMax={310}
                  rotateDegrees={-155}
                  onChange={(value) => {
                    const maxDistance = 50;
                    let distance = Math.abs(
                      value - this.state.reverb2Value * 100
                    );
                    if (distance > maxDistance) {
                      return;
                    } else {
                      this.handelReverb2(value);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <Knob
                  style={{
                    display: "inline-block",
                    width: "70%",
                    height: "73%",
                    left: "15%",
                    top: "3%",
                    // transform: "translate(-14.5%, -128%)",
                    // margin: "10px",
                    position: "relative",
                  }}
                  skin={filterKnob}
                  min={0}
                  max={100}
                  value={this.state.reverb1Value * 100}
                  unlockDistance={50}
                  clampMin={0}
                  clampMax={310}
                  rotateDegrees={-155}
                  onChange={(value) => {
                    const maxDistance = 50;
                    let distance = Math.abs(
                      value - this.state.reverb1Value * 100
                    );
                    if (distance > maxDistance) {
                      return;
                    } else {
                      this.handelReverb1(value);
                    }
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={44}>
            <Grid container style={styles.fullContainer}>
              <Grid item xs={2} style={{ padding: "0% 3% 7% 0%" }}>
                <UpDownButton
                  value={this.state.eqFilter1Value}
                  onValueChange={(value) => {
                    this.handelEQ1ValueChange(value);
                    this.setState({ eqFilter1Value: value });
                    // setEqFilter1Value(value);
                  }}
                />
              </Grid>
              <Grid item xs={2} style={{ padding: "0% 3% 7% 0%" }}>
                <UpDownButton
                  value={this.state.eqFilter2Value}
                  onValueChange={(value) => {
                    this.handelEQ2ValueChange(value);
                    this.setState({ eqFilter2Value: value });
                    // setEqFilter2Value(value);
                  }}
                />
              </Grid>
              <Grid item xs={2} style={{ padding: "0% 3% 7% 0%" }}>
                <UpDownButton value={3} onValueChange={() => {}} />
              </Grid>
              <Grid item xs={2} style={{ padding: "0% 3% 7% 0%" }}>
                <UpDownButton value={4} onValueChange={() => {}} />
              </Grid>
              <Grid item xs={2} style={{ padding: "0% 3% 7% 0%" }}>
                <UpDownButton value={5} onValueChange={() => {}} />
              </Grid>
              <Grid item xs={2} style={{ padding: "0% 3% 7% 0%" }}>
                <UpDownButton value={6} onValueChange={() => {}} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default UniversalControler;
